import { PayloadAction } from '@reduxjs/toolkit';
import { ITemplate, ITemplateInitial } from './template.types';

export const actions = {
  setTemplates(state: ITemplateInitial, { payload }: PayloadAction<ITemplate[]>) {
    state.templates = [...payload];
  },
};
